import React, { useState } from "react";
import { careerEndpoints } from "../../services/api";
import toast from "react-hot-toast";

const { INTERNSHIP_API } = careerEndpoints;

export default function InternshipForm() {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    city: "",
    file: null,
    collegeYear: "",
    from: "",
    to: "",
  });

  const [errors, setErrors] = useState({});

  // Handle Input Change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle File Upload
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData((prev) => ({ ...prev, file }));
  };

  // Validate Form
  const validateForm = () => {
    let newErrors = {};

    if (!formData.fullName) newErrors.fullName = "Full name is required";
    if (!formData.email) newErrors.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = "Invalid email format";
    
    if (!formData.city) newErrors.city = "City is required";
    if (!formData.collegeYear) newErrors.collegeYear = "College year is required";
    if (!formData.from) newErrors.from = "Start date is required";
    if (!formData.to) newErrors.to = "End date is required";
    else if (new Date(formData.to) < new Date(formData.from))
      newErrors.to = "End date cannot be before start date";

    if (!formData.file) newErrors.file = "Resume file is required";
    else if (!["application/pdf"].includes(formData.file.type))
      newErrors.file = "Only PDF  files are allowed";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle Form Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const toastId = toast.loading("Submitting...");

    try {
      const data = new FormData();
      data.append("fullName", formData.fullName);
      data.append("email", formData.email);
      data.append("city", formData.city);
      data.append("collegeYear", formData.collegeYear);
      data.append("from", formData.from);
      data.append("to", formData.to);
      data.append("file", formData.file);

      const response = await fetch(INTERNSHIP_API, {
        method: "POST",
        body: data,
      });

      if (!response.ok) {
        throw new Error("Failed to submit form");
      }

      toast.success("Form submitted successfully!");
      setFormData({
        fullName: "",
        email: "",
        city: "",
        file: null,
        collegeYear: "",
        from: "",
        to: "",
      });
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    } finally {
      toast.dismiss(toastId);
    }
  };

  return (
    <div className="mx-auto bg-[#F8F9FA] p-6">
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Full Name */}
        <div>
          <label className="block font-semibold">Full Name</label>
          <input
            type="text"
            name="fullName"
            className="w-full p-2 border rounded focus:ring-2 focus:ring-[#CFAF5A]"
            value={formData.fullName}
            onChange={handleChange}
          />
          {errors.fullName && <p className="text-red-500 text-sm">{errors.fullName}</p>}
        </div>

        {/* Email */}
        <div>
          <label className="block font-semibold">Email</label>
          <input
            type="email"
            name="email"
            className="w-full p-2 border rounded focus:ring-2 focus:ring-[#CFAF5A]"
            value={formData.email}
            onChange={handleChange}
          />
          {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
        </div>

        {/* City */}
        <div>
          <label className="block font-semibold">City</label>
          <input
            type="text"
            name="city"
            className="w-full p-2 border rounded focus:ring-2 focus:ring-[#CFAF5A]"
            value={formData.city}
            onChange={handleChange}
          />
          {errors.city && <p className="text-red-500 text-sm">{errors.city}</p>}
        </div>

        {/* College Year */}
        <div>
          <label className="block font-semibold">College Year</label>
          <input
            type="text"
            name="collegeYear"
            className="w-full p-2 border rounded focus:ring-2 focus:ring-[#CFAF5A]"
            value={formData.collegeYear}
            onChange={handleChange}
          />
          {errors.collegeYear && <p className="text-red-500 text-sm">{errors.collegeYear}</p>}
        </div>

        {/* Start Date */}
        <div>
          <label className="block font-semibold">Start Date</label>
          <input
            type="date"
            name="from"
            className="w-full p-2 border rounded focus:ring-2 focus:ring-[#CFAF5A]"
            value={formData.from}
            onChange={handleChange}
          />
          {errors.from && <p className="text-red-500 text-sm">{errors.from}</p>}
        </div>

        {/* End Date */}
        <div>
          <label className="block font-semibold">End Date</label>
          <input
            type="date"
            name="to"
            className="w-full p-2 border rounded focus:ring-2 focus:ring-[#CFAF5A]"
            value={formData.to}
            onChange={handleChange}
          />
          {errors.to && <p className="text-red-500 text-sm">{errors.to}</p>}
        </div>

        {/* File Upload */}
        <div>
          <label className="block font-semibold">Upload Resume (PDF )</label>
          <input
            type="file"
            name="file"
            accept=".pdf,.doc,.docx"
            className="w-full p-2 border rounded focus:ring-2 focus:ring-[#CFAF5A]"
            onChange={handleFileChange}
          />
          {errors.file && <p className="text-red-500 text-sm">{errors.file}</p>}
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="w-full p-3 bg-[#CFAF5A] text-[#0F172A] font-semibold rounded-lg hover:bg-[#B79527] transition duration-300"
        >
          Submit Application
        </button>
      </form>
    </div>
  );
}
